var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.777,
    height: 102.777,
    viewBox: "0 0 102.777 102.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485",
    transform: "translate(-930.82 -402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4757",
    "data-name": "Path 4757",
    d: "M52.638,104.027a51.388,51.388,0,1,1,51.388-51.388A51.432,51.432,0,0,1,52.638,104.027Zm0-95.606A44.218,44.218,0,1,0,96.856,52.638,44.271,44.271,0,0,0,52.638,8.42Z",
    transform: "translate(929.57 400.75)",
    fill: "#ee4e56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4758",
    "data-name": "Path 4758",
    d: "M24.1,42.675a3.582,3.582,0,0,1-2.534-1.052L8.042,28.1a3.583,3.583,0,1,1,5.067-5.067L24.1,34.023,48.675,9.452a3.583,3.583,0,1,1,5.067,5.067l-27.1,27.1A3.582,3.582,0,0,1,24.1,42.675Z",
    transform: "translate(951.314 427.827)",
    fill: "#ee4e56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.93616ea465ab776f288804688effba35.svg";
export { ForwardRef as ReactComponent };